import { ToolPageShell } from '@/shared/seo'
import { FlattenPdfForm } from './FlattenPdfForm'

export function FlattenPdfPage() {
  return (
    <ToolPageShell utilityKey="flatten-pdf">
      <FlattenPdfForm />
    </ToolPageShell>
  )
}
